import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function KeyContainer({ children, ...props }: FlexProps) {
  return (
    <Flex
      bg="white"
      borderRadius="10px"
      boxShadow="0px 2px 12px 0px rgba(16, 24, 40, 0.08)"
      gap={{ base: 8, lg: 10 }}
      py={{ base: 4, lg: 5 }}
      px={{ base: 5, lg: 6 }}
      {...props}
    >
      {children}
    </Flex>
  );
}
